<template>
  <div class="tear-card" :style="{'--out-bg-color': themeColors.outBg, '--card-bg-color': themeColors.cardBg}">
    <slot />
  </div>
</template>

<script setup>
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '@/../tailwind.config'
import {computed} from "vue";

const fullConfig = resolveConfig(tailwindConfig)

const themeColors = computed(() => {


  let card_bg, out_bg
  if(props.cardBgColor.indexOf('#') >= 0) {
    card_bg = props.cardBgColor;
  } else {
    card_bg = fullConfig.theme.colors[props.cardBgColor][props.cardBgColorRange.toString()] || ""
  }

  if(props.outBgColor.indexOf('#')  >= 0) {
    out_bg = props.outBgColor;
  } else {
    out_bg = fullConfig.theme.colors[props.outBgColor][props.outBgColorRange.toString()] || ""
  }

  return {
    cardBg: card_bg,
    outBg: out_bg
  }
})

const props = defineProps({
  outBgColor: {
    type: String,
    default: '#ccc'
  },

  outBgColorRange: {
    type: String,
    default: '100'
  },
  cardBgColor: {
    type: String,
    default: '#fff'
  },
  cardBgColorRange: {
    type: String,
    default: '100'
  },
})
</script>

<style scoped>
.tear-card {
  min-height: 220px;
  background: var(--card-bg-color);
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

/* ایجاد نیم‌دایره‌های پایین کارت */
.tear-card::after {
  content: "";
  position: absolute;
  bottom: -7px; /* ارتفاع نیم‌دایره */
  left: 0;
  width: 100%;
  height: 14px;
  background-repeat: repeat-x;
  background-size: 14px 14px; /* قطر دایره‌ها */
  background-image:
    radial-gradient(circle,  var(--out-bg-color) 50%, var(--card-bg-color) 50%);
}
</style>
